var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["loyalty-full-form-intro.j2"] = require( "loyalty-full-form-intro.j2" );
dependencies["loyalty-general-errors.j2"] = require( "loyalty-general-errors.j2" );
dependencies["loyalty-required-instructions.j2"] = require( "loyalty-required-instructions.j2" );
dependencies["loyalty-email-signup-fields.j2"] = require( "loyalty-email-signup-fields.j2" );
dependencies["loyalty-email-address-divider.j2"] = require( "loyalty-email-address-divider.j2" );
dependencies["loyalty-address-fields.j2"] = require( "loyalty-address-fields.j2" );
dependencies["loyalty-address-birthday-divider.j2"] = require( "loyalty-address-birthday-divider.j2" );
dependencies["loyalty-birthday-fields.j2"] = require( "loyalty-birthday-fields.j2" );
dependencies["loyalty-submit.j2"] = require( "loyalty-submit.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-full-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("loyalty-full-form-intro.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n<form novalidate data-form-type=\"fullForm\" data-parsley-validate action=\"#\" method=\"post\" class=\"c-form js-loyalty-form\" data-qa-loyalty-fullform>\n\n    ";
env.getTemplate("loyalty-general-errors.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    ";
env.getTemplate("loyalty-required-instructions.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n    ";
env.getTemplate("loyalty-email-signup-fields.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n    ";
env.getTemplate("loyalty-email-address-divider.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n    ";
env.getTemplate("loyalty-address-fields.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n    ";
env.getTemplate("loyalty-address-birthday-divider.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n\n    ";
env.getTemplate("loyalty-birthday-fields.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
t_29.render(context.getVariables(), frame, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
output += t_30
output += "\n\n    ";
env.getTemplate("loyalty-submit.j2", false, "loyalty/templates/loyalty-full-form.j2", null, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
t_33.render(context.getVariables(), frame, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
output += t_34
output += "\n\n</form>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-full-form.j2"] , dependencies)